module.exports = __webpack_public_path__ + "img/71_7.1fbba697.png";